const e = "badge", g = {
  badge: e,
  "badge--orange": "badge--orange",
  "badge--blue": "badge--blue",
  "badge--yellow": "badge--yellow",
  "badge--green": "badge--green",
  "badge--red": "badge--red",
  "badge--purple": "badge--purple",
  "badge--neutral": "badge--neutral",
  "badge--grey": "badge--grey",
  "badge--roche-blue": "badge--roche-blue",
  "badge--extra-light-blue": "badge--extra-light-blue",
  "badge--light-blue": "badge--light-blue",
  "badge--navy": "badge--navy",
  "badge--dark-green": "badge--dark-green",
  "badge--bright-green": "badge--bright-green"
};
export {
  e as badge,
  g as default
};
